import React, { Component } from 'react';
import { connect } from 'react-redux';
import NoticeProductListWrap from '../../views/notice/product/list/NoticeProductListWrap';
import { noticeProductActions } from '../../store/modules/notice/product';
import {
  NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL,
  NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/notice/product/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NOTICE_PRODUCT_STATUS } from '../../constants/service/app/noticeProductConstants';
import { asyncSimpleModal } from '../../lib/common';

class NoticeProductListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { getNoticeProductList } = this.props;
    getNoticeProductList({
      filterOption: NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL,
      sortOption: NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  getList = (data) => {
    const { getNoticeProductList, noticeProductList } = this.props;
    const { filterOption, sortOption, pagination } = noticeProductList;
    getNoticeProductList({
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  getExcelDownload = () => {
    const { getNoticeProductExcelDownload, noticeProductList } = this.props;
    const { filterOption, sortOption } = noticeProductList;

    getNoticeProductExcelDownload({
      filterOption,
      sortOption,
    });
  };

  /**
   * 상품 공지사항 삭제하기
   */
  deleteNoticeProduct = async (productNoticeId, productNoticeStatus) => {
    const { deleteNoticeProduct } = this.props;

    if (productNoticeStatus === NOTICE_PRODUCT_STATUS.DELETE_FROM_ADMIN) {
      await asyncSimpleModal({
        title: '상품 공지사항 삭제',
        message: '이미 삭제된 공지사항입니다.',
      });
      return;
    }

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '상품 공지사항 삭제',
      message: '정말로 삭제를 하시겠습니까?',
    });

    if (!confirmResult) return;

    deleteNoticeProduct({ productNoticeId });
  };

  render() {
    const { noticeProductList } = this.props;

    return (
      <NoticeProductListWrap
        noticeProductList={noticeProductList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
        deleteNoticeProduct={this.deleteNoticeProduct}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    noticeProductList: state.noticeProduct.noticeProductList,
  };
};

const mapDispatchToProps = {
  setData: noticeProductActions.setData,
  getNoticeProductList: noticeProductActions.getNoticeProductList,
  getNoticeProductExcelDownload: noticeProductActions.getNoticeProductExcelDownload,
  deleteNoticeProduct: noticeProductActions.deleteNoticeProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(NoticeProductListContainer);
